import axiosClient from "client/axios-client";
import type { SubscriptionGroupDto } from "./CloudSubscriptionApi";
import type { ListEntitiesResponse } from "./ListEntitiesResponse";
import type { ListQuery } from "./common/ListQuery";

export enum ProductType {
  ServerLicense = "server-licenses",
  CloudSubscription = "cloud-subscriptions",
}

export const addToNewSubscriptionGroup = async (
  id: string,
  newSubscriptionGroupName: string,
  productType: ProductType
): Promise<void> => {
  await axiosClient.put(`${productType}/${id}/subscription-group/add-new`, {
    newSubscriptionGroupName,
  });
};

export const addToExistingSubscriptionGroup = async (
  id: string,
  existingId: string,
  productType: ProductType
): Promise<void> => {
  await axiosClient.put(`${productType}/${id}/subscription-group/add-existing`, {
    existingId,
  });
};

export type GetSubscriptionGroupResponse = ListEntitiesResponse<SubscriptionGroupDto>;

export const getSubscriptionGroups = async (query: ListQuery): Promise<GetSubscriptionGroupResponse> => {
  const response = await axiosClient.get<GetSubscriptionGroupResponse>("subscription-groups/search", {
    params: query,
  });
  return response.data;
};
